"use client";

import type { HomepageVariant } from "@packages/sdk";
import {
  getCookieHomepageVariant,
  usePathMatch,
  useSession,
} from "@packages/sdk";

export function useIsSSTest({
  variants,
}: {
  variants: HomepageVariant[];
}): boolean {
  const matcher = usePathMatch();
  const session = useSession();
  const homepageVariant = getCookieHomepageVariant();

  return (
    variants.includes(homepageVariant) &&
    matcher("/") &&
    session.status === "unauthenticated"
  );
}
